import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('PaymentCard');

const propTypes = {
    card: PropTypes.string,
    className: PropTypes.string
};

const PaymentCard = ({ card, className }) => <li className={bem(card?.replace('_', '').toLowerCase(), null, className)} />;

PaymentCard.propTypes = propTypes;

export default PaymentCard;
